import React from 'react';

/** The gradient CTA pill (54px, #676AF6→#36CEE5, blue glow). */
const CtaButton = ({ children, onClick, disabled = false, type = 'button' }) => (
	<button
		type={type === 'submit' ? 'submit' : 'button'}
		disabled={disabled}
		onClick={onClick}
		className="flex h-[54px] w-full shrink-0 cursor-pointer items-center justify-center rounded-full bg-gradient-to-br from-pay-purple to-pay-teal text-[16px] font-bold text-white shadow-cta transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
	>
		{children}
	</button>
);

export default CtaButton;
